const validateFileSize = (fileSize) => {
  const maxSize = 12000000;

  if (fileSize > maxSize) {
    return false;
  }

  return true;
};

export default validateFileSize;
